<template>
  <v-container grid-list-xl text-xs-center>
    <div class="title my-5">Statuts de synchronisation</div>
    <v-layout row wrap>
      <v-flex sm4 xl2 v-for="s in status" :key="s._id">
        <v-card class="button py-4" @click="handleClick(s._id)">
          <v-card-text>
            <div>
              <v-timeline-item
                small
                :color="s.status === 'pending' ? 'orange': 'green'"
                class="mt-4 mb-3"
              ></v-timeline-item>
            </div>
            <div>{{s._id}}</div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import files from "../doc/files";

export default {
  data: () => ({
    status: undefined
  }),
  async mounted() {
    const { data: status } = await axios({
      method: "GET",
      url: `${process.env.VUE_APP_API_URI}/status`
    });
    this.status = status;
  },
  methods: {
    handleClick: function(item) {
      const { route } = files.find(f => f.name === item);
      this.$router.push(route);
    }
  }
};
</script>

<style>
.button {
  cursor: pointer;
}
</style>


